import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Card, CardBody, CardTitle, Col, Row, Badge } from 'reactstrap';
import { Th, Thead, Tr } from 'react-super-responsive-table';

import { getDmxProfiles, deleteDmxProfile } from '../../store/actions';

class DmxDeviceProfileList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      showConfirm: false,
      profileToDelete: null,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingDeleteDmxProfile === false && prevProps.loadingDeleteDmxProfile === true) {
      this.props.getDmxProfiles(this.state.user);
      if (this.props.deleteDmxProfileError) {
        this.setState({
          popup: true,
          pop_msg: this.props.deleteDmxProfileError.message || 'Error al eliminar el perfil',
          alertType: 'error',
        });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  confirmDelete(profile) {
    this.setState({ showConfirm: true, profileToDelete: profile });
  }

  doDelete() {
    const { user, profileToDelete } = this.state;
    this.props.deleteDmxProfile({ id: profileToDelete.id, token: user.token });
    this.setState({ showConfirm: false });
  }

  render() {
    const { profileList } = this.props;
    return (
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{this.props.t('Perfiles DMX')}</CardTitle>
              <div className="table-responsive">
                <table className="table table-centered table-nowrap mb-0">
                  <Thead>
                    <Tr>
                      <Th>{this.props.t('Nombre')}</Th>
                      <Th>{this.props.t('Tipo')}</Th>
                      <Th>{this.props.t('Canales')}</Th>
                      <Th>{this.props.t('Actions')}</Th>
                    </Tr>
                  </Thead>
                  <tbody>
                    {profileList.map((p) => (
                      <tr key={p.id}>
                        <td>
                          <span>{p.name}</span>
                        </td>
                        <td>
                          <Badge color={p.device_type === 'LED' ? 'info' : 'warning'} className="font-size-13" pill>
                            {p.device_type}
                          </Badge>
                        </td>
                        <td>
                          <span>{p.channel_count}</span>
                        </td>
                        <td>
                          <button
                            className="btn btn-primary waves-effect waves-light buttonStatus txtField"
                            title="Detalle"
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/dmxDeviceProfileDetail/${p.id}`,
                                state: p,
                              })
                            }
                          >
                            <i className="mdi mdi-pencil font-size-14 align-middle"></i>
                          </button>
                          <button
                            className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                            title="Eliminar"
                            onClick={() => this.confirmDelete(p)}
                          >
                            <i className="far fa-trash-alt font-size-14 align-middle"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title="¿Estás seguro?"
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doDelete()}
            onCancel={() => this.setState({ showConfirm: false })}
          >
            {this.props.t('Solo se puede borrar un perfil que no esté en uso por ningún dispositivo')}
          </SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          ></SweetAlert>
        ) : null}
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const { loadingDeleteDmxProfile, deleteDmxProfileError } = state.deleteDmxProfile;
  return { loadingDeleteDmxProfile, deleteDmxProfileError };
};

export default withRouter(
  connect(mapStateToProps, { getDmxProfiles, deleteDmxProfile })(withNamespaces()(DmxDeviceProfileList)),
);
